export default __webpack_public_path__ + "assets/a6b0418f2e22e0650a2231f0e7dbbc33.jpg";